import styled from 'styled-components';

import { media } from '../../../../../helpers/breakpoints';
import { Button } from '../../../../Toolkit/Button';
import { Loading } from '../../../../Toolkit/Loading/Loading';
import { Panel } from '../../../components/Panels/shared/Panel/Panel';

export const Content = styled(Panel)`
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.medium} {
    justify-content: flex-end;
  }
`;

// https://www.linkedin.com/posts/wesbos_how-do-you-make-a-button-that-doesnt-resize-activity-7272663944106782720-ksgB
export const SubmitButton = styled(Button)`
  display: grid;
  grid-template-areas: 'stack';
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${media.medium} {
    width: fit-content;
    padding: ${({ theme }) => `0 ${theme.spacing.S12}`};
    margin-bottom: 0;
  }
`;

export const ButtonText = styled.span<{ isSubmitting: boolean }>`
  grid-area: stack;
  ${({ isSubmitting }) => isSubmitting && 'opacity: 0;'}
`;

export const Spinner = styled(Loading)<{ isSubmitting: boolean }>`
  grid-area: stack;
  justify-self: center;
  ${({ isSubmitting }) => !isSubmitting && 'opacity: 0;'}
`;
